import { useState } from "react";
import { FiGrid, FiPlus } from "react-icons/fi";
import PhotoUpload from "./components/PhotoUpload";
import PhotoGallery from "./components/PhotoGallery";

function App() {
  const [activeTab, setActiveTab] = useState<"gallery" | "upload">("gallery");
  const [refreshGallery, setRefreshGallery] = useState(0);

  const handlePhotoUploaded = (allSuccessful: boolean = false) => {
    setRefreshGallery((prev) => prev + 1);
    if (allSuccessful) {
      setActiveTab("gallery");
    }
  };

  return (
    <div className="min-h-screen bg-gradient">
      <header className="header-section">
        <div className="mobile-container">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Fotos do Casamento
          </h1>
          <p className="text-base md:text-lg text-gray-600 leading-relaxed">
            Compartilhe seus momentos especiais conosco
          </p>
        </div>
      </header>

      <main className="main-section">
        <div className="mobile-container">
          <div className="flex bg-white rounded-2xl p-1 mb-6 shadow-sm">
            <button
              onClick={() => setActiveTab("gallery")}
              className={`flex-1 flex items-center justify-center space-x-2 py-3 px-4 rounded-xl font-semibold transition-all duration-200 ${
                activeTab === "gallery"
                  ? "bg-olive-green text-white shadow-sm"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              <FiGrid className="w-5 h-5" />
              <span>Galeria</span>
            </button>
            <button
              onClick={() => setActiveTab("upload")}
              className={`flex-1 flex items-center justify-center space-x-2 py-3 px-4 rounded-xl font-semibold transition-all duration-200 ${
                activeTab === "upload"
                  ? "bg-olive-green text-white shadow-sm"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              <FiPlus className="w-5 h-5" />
              <span>Enviar</span>
            </button>
          </div>

          {activeTab === "gallery" ? (
            <PhotoGallery
              key={refreshGallery}
              onPhotoUploaded={handlePhotoUploaded}
            />
          ) : (
            <PhotoUpload onUploadComplete={handlePhotoUploaded} />
          )}
        </div>
      </main>

      <footer className="text-center py-8 px-4 bg-white border-t border-gray-100 safe-area-bottom">
        <p className="text-sm text-gray-500">
          Feito com ❤️ para memórias lindas
        </p>
      </footer>
    </div>
  );
}

export default App;
